import React from "react";
import Preloader from "../helper/Preloader";
import HeaderTwo from "../components/HeaderTwo";
import ShopSection from "../components/Refine/ShopSection";
import ShippingTwo from "../components/ShippingTwo";
import FooterTwo from "../components/FooterTwo";
import ColorInit from "../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";

const ShopPage = () => {

  return (
    <>
      {/* ColorInit */}
      <ColorInit color={true} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400" />

      {/* Preloader */}
      <Preloader />

      {/* HeaderOne */}
      <HeaderTwo category={true} />

      <div className="banner mt-0">
        <img src="/assets/images/banner/shops.jpg" className="w-100" alt="" />
      </div>

      {/* ShopSection */}
      <ShopSection />

      {/* FooterTwo */}
      <FooterTwo />


    </>
  );
};

export default ShopPage;
